(function () {
    if (typeof window === "undefined" || window.listenToClicks) return;

    var MAX_VALUE_LENGTH = 100;
    var CLIPPED_VALUE_SUFFIX = '...';
    var CLICKABLE_ATTRIBUTES = ['data-clickable', 'onclick'];
    var CLICKABLE_PROPS = ['onClick', 'onMouseDown', 'onMouseUp'];
    var CLICKABLE_TAGS = ['A', 'BUTTON'];

    var ELEMENT_DATA_FUNCTIONS = {
        id: function (element) {
            return prepareValue(element.id || '')
        },
        class: function (element) {
            var value = (!isSvgElement(element) && element.className) || '';
            return prepareValue(value);
        },
        tid: function (element) {
            return prepareValue(element.getAttribute('data-tid') || '')
        },
        text: function (element) {
            return prepareValue(element.textContent || '')
        }
    };

    function prepareValue(value) {
        var val = value.replace(/\s+/g, ' ').trim();
        if (val.length > MAX_VALUE_LENGTH) {
            return val.slice(0, MAX_VALUE_LENGTH - CLIPPED_VALUE_SUFFIX.length) + CLIPPED_VALUE_SUFFIX;
        }
        return val;
    }

    function isSvgElement(element) {
        return element instanceof SVGElement;
    }

    function deleteClickListener(callback) {
        return function() {
            callbacks = callbacks.filter(function(cb) {
                return cb !== callback;
            });
        }
    }

    function listenToClicks(callback) {
        callbacks.push(callback);
        return deleteClickListener(callback);
    }

    var mouseTarget = null;
    var callbacks = [];

    window.document.addEventListener('mousedown', function (event) {
        mouseTarget = event.target;
    });
    window.document.addEventListener('mouseup', function (event) {
        var target = event.target;
        if (mouseTarget === target) {
            var isLink = target.tagName === 'A';
            var isButton = target.tagName === 'BUTTON';
            var style = window.getComputedStyle(target);
            var hasCursorPointer = style && style.cursor === 'pointer';
            if (
                isLink ||
                isButton ||
                hasCursorPointer ||
                checkAncestorIs('A', target) ||
                checkAncestorIs('BUTTON', target)
            ) {
                var trackData = buildTrackData(target);
                callbacks.forEach(function (callback) {
                    callback(trackData);
                });
            }
        }
        mouseTarget = null;
    }, true);

    function checkAncestorIs(tagName, element) {
        var result = false;
        var parent = getParent(element);
        while (parent) {
            if (parent.tagName === tagName) {
                result = true;
                break;
            } else {
                parent = getParent(parent);
            }
        }
        return result;
    }

    function buildTrackData(target) {
        return Object.assign({},
            getTargetProperties(target),
            getClickableElementProperties(target)
        );
    }

    function getTargetProperties(element) {
        return element ? {
            'own_class': ELEMENT_DATA_FUNCTIONS.class(element),
            'own_tid': ELEMENT_DATA_FUNCTIONS.tid(element)
        } : {
            'own_class': '',
            'own_tid': ''
        }
    }

    function getClickableElementProperties(element) {
        var clickableElement = isClickable(element) ? element : findClickableAncestor(element);
        return clickableElement ? {
            'id': ELEMENT_DATA_FUNCTIONS.id(clickableElement),
            'class': ELEMENT_DATA_FUNCTIONS.class(clickableElement),
            'tid': ELEMENT_DATA_FUNCTIONS.tid(clickableElement),
            'text': ELEMENT_DATA_FUNCTIONS.text(clickableElement)
        } : {
            'id': '',
            'class': '',
            'tid': '',
            'text': ''
        };
    }

    function findClickableAncestor(element) {
        var parent = getParent(element);
        while (parent && !isClickable(parent)) {
            parent = getParent(parent);
        }
        return parent;
    }

    function isClickable(element) {
        for (var i = 0; i < CLICKABLE_ATTRIBUTES.length; i++) {
            if (element.getAttribute(CLICKABLE_ATTRIBUTES[i]) != null) {
                return true;
            }
        }
        for (var i = 0; i < CLICKABLE_TAGS.length; i++) {
            if (element.tagName === CLICKABLE_TAGS[i]) {
                return true;
            }
        }

        var instancePropName = Object.keys(element).find(function(key) {
            return key.includes("Instance")
        })

        if (instancePropName) {
            var instance = element[instancePropName];
            if (instance.pendingProps) {
                return CLICKABLE_PROPS.some(function(prop) {
                    return instance.pendingProps[prop]
                });
            }
            if (instance.memoizedProps) {
                return CLICKABLE_PROPS.some(function(prop) {
                    return instance.memoizedProps[prop]
                });
            }
        }


        return false;
    }

    function getParent(element) {
        return element.parentNode === window.document ? null : element.parentNode;
    }

    window.listenToClicks = listenToClicks;
})();
